import { MrModalDialog } from '@mrhenry/wp--mr-interactive';

class MrPersonDetail extends MrModalDialog {
	constructor() {
		super();
	}

	override async willOpen() {
		await super.willOpen();
		document.body.classList.add( 'is-showing-overlay' );
	}

	override async willClose() {
		await super.willClose();
		document.body.classList.remove( 'is-showing-overlay' );
	}

	override openAnimations() {
		if ( !( 'KeyframeEffect' in window ) ) {
			return [];
		}

		return [
			new KeyframeEffect(
				this,
				[
					{
						opacity: 0,
					},
					{
						opacity: 1,
					},
				],
				{
					duration: 384,
					easing: 'ease-in-out',
					fill: 'forwards',
				}
			),
		];
	}

	override closeAnimations() {
		if ( !( 'KeyframeEffect' in window ) ) {
			return [];
		}

		return [
			new KeyframeEffect(
				this,
				[
					{
						opacity: 1,
					},
					{
						opacity: 0,
					},
				],
				{
					duration: 128,
					easing: 'ease-in-out',
					fill: 'forwards',
				}
			),
		];
	}
}

customElements.define( 'mr-person-detail', MrPersonDetail );
